import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const IconHome = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);
const IconUsers = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);
const IconTarget = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
  </svg>
);
const IconChart = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/>
  </svg>
);
const IconSettings = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14"/>
  </svg>
);
const IconList = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/>
    <line x1="8" y1="18" x2="21" y2="18"/>
    <line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/>
    <line x1="3" y1="18" x2="3.01" y2="18"/>
  </svg>
);
const IconUser = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);

export default function BottomNav() {
  const { canManage, canSupervise } = useAuth();

  const navItems = [
    { to: '/',        label: 'الرئيسية', icon: <IconHome /> },
    ...(canSupervise ? [{ to: '/team',    label: 'الفريق',   icon: <IconUsers /> }] : []),
    ...(canSupervise ? [{ to: '/targets', label: 'الأهداف',  icon: <IconTarget /> }] : []),
    ...(canManage    ? [{ to: '/reports', label: 'التقارير', icon: <IconChart /> }] : []),
    ...(canManage    ? [{ to: '/admin',   label: 'الإدارة',  icon: <IconSettings /> }] : []),
    { to: '/history', label: 'السجل',    icon: <IconList /> },
    { to: '/profile', label: 'حسابي',    icon: <IconUser /> },
  ];

  return (
    <nav style={styles.nav}>
      {navItems.map(item => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          style={({ isActive }) => ({
            ...styles.item,
            color: isActive ? 'var(--primary)' : 'var(--gray-400)',
          })}
        >
          {({ isActive }) => (
            <>
              <div style={{
                ...styles.iconWrap,
                background: isActive ? 'var(--primary-light)' : 'transparent',
              }}>
                {item.icon}
              </div>
              <span style={{ ...styles.label, fontWeight: isActive ? 700 : 400 }}>
                {item.label}
              </span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}

const styles = {
  nav: {
    position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
    width: '100%', maxWidth: 480, height: 'var(--bottom-nav-height)',
    background: 'white', borderTop: '1px solid var(--gray-100)',
    display: 'flex', alignItems: 'center', justifyContent: 'space-around',
    padding: '0 4px', paddingBottom: 'env(safe-area-inset-bottom)',
    zIndex: 100, boxShadow: '0 -4px 20px rgba(0,0,0,0.06)',
  },
  item: {
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
    padding: '4px 4px', borderRadius: 12, textDecoration: 'none',
    transition: 'color 0.2s', minWidth: 40, flex: 1,
  },
  iconWrap: {
    padding: 5, borderRadius: 10, transition: 'background 0.2s',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  label: { fontSize: 9, lineHeight: 1 },
};
